import { Link } from "react-router-dom";

export default function OrderActions({
  loading,
  progress = {
    value: 0,
    message: "Preparando las imagenes...",
  },
  onReset,
  onFinishOrder,
  submitLabel = "Finalizar pedido",
}) {
  return (
    <div className="actions">
      <button
        onClick={onReset}
        disabled={loading}
        className="reset-btn"
        type="button"
      >
        Borrar imagen
      </button>

      <button
        onClick={onFinishOrder}
        disabled={loading}
        className="final-order-btn"
        type="button"
      >
        {loading ? "Procesando..." : submitLabel}
      </button>

      <Link to="/carrito" className="view-cart-link">
        Ver carrito
      </Link>

      {loading && (
        <div
          className="order-progress"
          role="status"
          aria-live="polite"
          aria-label={progress.message}
        >
          <div className="order-progress-heading">
            <span>{progress.message}</span>
            <strong>{progress.value}%</strong>
          </div>

          <div
            className="order-progress-track"
            role="progressbar"
            aria-valuemin="0"
            aria-valuemax="100"
            aria-valuenow={progress.value}
          >
            <span style={{ width: `${progress.value}%` }} />
          </div>

          <small>No cierres esta pagina mientras preparamos las imagenes.</small>
        </div>
      )}
    </div>
  );
}
